import { useMemo, useState } from 'react';
import userSvg from '../../../../assets/images/default_man.png';
import searchSvg from '../../../../assets/images/svgs/search.svg';
import { displayName } from '../../application/mapChat';
import type { ChatRoomSummary } from '../../application/types';
import { useChatRooms } from '../hooks/useChatRooms';

export type RoomListProps = {
  onSelectChat?: (room: ChatRoomSummary) => void;
  showOnlyFirstChat?: boolean;
  showSearch?: boolean;
  selectedRoomId?: string | null;
};

export function RoomList({
  onSelectChat,
  showOnlyFirstChat = false,
  showSearch = true,
  selectedRoomId = null,
}: RoomListProps) {
  const { rooms, currentUserId } = useChatRooms();
  const [searchQuery, setSearchQuery] = useState('');

  const filteredRooms = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    let list = rooms;

    if (showOnlyFirstChat && currentUserId) {
      list = list
        .filter((room) => room.participants.includes(currentUserId))
        .slice(0, 1);
    }

    if (!q) {
      return list;
    }

    return list.filter((room) => {
      const name = displayName(room.peer).toLowerCase();
      return name.includes(q);
    });
  }, [rooms, searchQuery, showOnlyFirstChat, currentUserId]);

  return (
    <div className="room">
      {showSearch && (
        <div className="room-search">
          <div className="custom-form-group">
            <img src={searchSvg} className="input-svg" alt="" />
            <input
              type="text"
              name="search"
              placeholder="Пошук по імені..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="custom-form-control chat-filter-form-control"
            />
          </div>
        </div>
      )}

      <ul className="room-list">
        {filteredRooms.map((room) => {
          const active =
            selectedRoomId === room.id ||
            selectedRoomId === room.peer.id;
          return (
            <li
              key={room.id}
              className={`room-list__item${active ? ' selected' : ''}`}
              onClick={() => onSelectChat?.(room)}
            >
              <img src={room.peer.picture || userSvg} alt="" />
              <div className="room-list__item-data">
                <p className="room-list__item-data-name">
                  {displayName(room.peer)}
                </p>
                <p className="room-list__item-data-text">Some description...</p>
              </div>
              <span className="room-list__item-date">
                {room.createdAt
                  ? new Date(room.createdAt).toLocaleTimeString()
                  : ''}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default RoomList;
